import { render, staticRenderFns } from "./TaxesTypeRadioGroup.vue?vue&type=template&id=36814ff4&scoped=true&"
import script from "./TaxesTypeRadioGroup.vue?vue&type=script&lang=js&"
export * from "./TaxesTypeRadioGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36814ff4",
  null
  
)

export default component.exports